import React, { useEffect } from 'react';
import AssetSearch from "../pages/AssetSearch";
const AssetSearchComponent = ({ dataa, isFromEligible, learnWhyAction, onChangeText, action, triggerAction, height }) => {
    useEffect(() => {
        console.warn("DSADASDASDASDASDAS", isFromEligible);
    }, [isFromEligible]);
    return (React.createElement(AssetSearch, { data: [], dataa: dataa, onFitlerSet: () => { }, isFromEligible: isFromEligible, onChangeText: (text) => {
            if (onChangeText) {
                onChangeText(text);
            }
            if (action && triggerAction) {
                triggerAction({
                    ...action,
                    payload: {
                        ...action.payload,
                        value: text,
                    },
                });
            }
        }, learnWhyAction: learnWhyAction, triggerAction: triggerAction, height: height }));
};
export default AssetSearchComponent;
export { AssetSearchComponent };
